<script setup lang="ts">

import { LoginForm } from './components';

defineOptions({
  name: 'Login'
});

const bgContainerRef = ref();

const handleResize = () => {
  const { innerWidth, innerHeight } = window;
  const bgContainer = bgContainerRef.value;
  console.log('handleResize', innerWidth, innerHeight, bgContainer);
  if (bgContainer) {
    const size = Math.min(innerWidth, innerHeight) + 100;
    bgContainer.style.width = `${size}px`;
    bgContainer.style.height = `${size}px`;
  }
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
  handleResize();
});

</script>

<template>
  <q-layout view="lHr LpR lFr">
    <q-page-container class="bg-common-1">
      <q-page class=" column login-page relative-position">
        <div class="bg-container" ref="bgContainerRef">
          <q-img
            style="
            transform: translateX(30%) translateY(10%);
            filter: blur(10px) brightness(90%)"
            src="/svg/logo.webp"
            :ratio="1"
            fit="contain"
            height="100%">
            <template #loading>
            </template>
          </q-img>
        </div>
        <div class="login-icon column items-center full-width q-pa-lg q-px-xl">
          <!--          <q-icon name="app:index.webp" class="text-h1 full-width" />-->
          <q-img src="/svg/index.webp" :ratio="16/9" fit="contain" height="9vh">
            <template #loading>
            </template>
          </q-img>
        </div>
        <q-card class="bg-transparent q-px-lg q-py-xl col-grow radius-top-lg no-shadow login-container">
          <LoginForm />
        </q-card>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<style lang="scss" scoped>

@keyframes bg-animation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.login-page {

  //background-image: url('/svg/bg.svg');
  //background-size: cover; /* 或者可以使用contain来保持SVG的原始大小 */
  //background-repeat: no-repeat;
  //background-position: center;

  //background: linear-gradient(125deg,
  //  #2b3141, #31394C, #2d4671, #2b3141, #2b3141, #2d4671, #31394C, #2b3141);
  ///* 重复设置颜色，达到水波纹效果 */
  //background-size: 300%;
  //animation: bg-animation 20s infinite;

  //background-image: linear-gradient(to bottom, #d16ba5, #c777b9, #ba83ca, #aa8fd8, #9a9ae1, #8aa7ec, #79b3f4, #69bff8, #52cffe, #41dfff, #46eefa, #5ffbf1);

  .login-icon {
    z-index: 10;
    transform: translateY(50%);
  }

  .login-container {
  }

  .bg-container {
    overflow: hidden;
    //z-index: 0;
    position: absolute;
    right: 0;
    bottom: 0;

    //backdrop-filter: blur(10px) brightness(90%);
    //background-color: rgba(66,152,91,0.3);
    //border-radius: 20px
    //width: 500px;
    //height: 500px;

    //background-image: url('@/assets/bg/logo.webp');
    //background-repeat: no-repeat;
    //backdrop-filter: blur(20px);
    //background: #fa5a65;
    //border-top-left-radius: 150% 150%;
    //border-top-right-radius: 50% ;

    //border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
    //border-radius: 36% 64% 73% 27% / 74% 51% 49% 26%;
  }
}

</style>